import React, { useContext } from 'react';
import LangContext from '../../context/LangContext';

const Footer = () => {

    const { currentLangData } = useContext(LangContext);

    return(
        <div style={{ width: '100%', height: 'auto', padding: '1.45em 1.4em', display: 'flex', alignItems: 'center', justifyContent: 'center' }} >
            <span className="main-title-color" style={{ fontSize: '.85rem', textAlign: 'center' }} >
                {currentLangData.FOOTER.title}
            </span>
        </div>
    )
}

export default Footer;